import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../constants/colors/Colors";
export const useStyles = makeStyles((theme) => ({

  MainPage: {
    backgroundColor: colors.primary,
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
  },
  PasswordContainer: {
    backgroundColor: 'rgb(255, 255, 255 , 0.92)',
    height: 'auto',
    width: '50%',
    margin: '0 auto',
    borderRadius: 36,
    paddingTop: '50px',
    paddingBottom: '50px',
    "@media (min-width: 1800px)": {
      width: '776px',
    },
    "@media (max-width: 1800px)": {
      width: '42%',
    },
    "@media (max-width: 1600px)": {
      width: '60%',
    },
    "@media (max-width: 650px)": {
      width: '90%',
    },
  },
  HeaderContainer: {
    marginTop: 40,
    paddingTop: '30px',
    paddingBottom: '30px',
    backgroundColor: '#ffffff',
    borderRadius: 18,
    height: '70%',
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
    "@media (min-width: 1800px)": {
      width: '576px',
    },
    "@media (max-width: 600px)": {
      width: '90%',
    },
  },
  PasswordHeading: {
    textAlign: "center",
  },
  text: {
    fontSize: "50px",
    fontWeight: "bold",
    padding: "0px",
    margin: "0px",
    "@media (max-width: 428px)": {
      fontSize: '40px'
    },
  },

  HeaderdHeading: {
    margin: 0,
    fontStyle: "normal",
    textAlign: "center",
    fontWeight: "600",
    color: "#091E42",
    fontSize: "34px",
    letterSpacing: "-0.02em",
    marginTop: 20,
    marginBottom: "40px",
    fontFamily: 'WorkSans-SemiBold',
    "@media (min-height: 700px)": {
      marginTop: 30,
      marginBottom: "50px",
    },
    "@media (max-width: 428px)": {
      fontSize: '28px'
    },
  },
  InputFieldHeading: {
    width: "80%",
    margin: 0,
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 16,
    color: colors.titleColor,
    fontWeight: "400",
    fontFamily: 'Roboto-Regular',
    "@media (max-width: 700px)": {
      width: "90%",
    },
  },
  IconAndInputField: {
    width: "80%",
    marginTop: 10,
    marginLeft: "auto",
    marginRight: "auto",
    alignItems: "center",
    "@media (max-width: 700px)": {
      width: "90%",
    },
  },
  Input: {
    backgroundColor: '#D4DDE4',
    outline: 'none',
    width: "100%",
    height: 46,
    borderWidth: 1,
    padding: "15px 15px",
    boxSizing: "border-box",
    border: "1px solid #D4DDE4",
    borderRadius: 6,
    fontFamily: 'Roboto-Regular',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 16,
    color: '#94999E',

  },
  ButtonContainer: {
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
    "@media (max-width: 700px)": {
      width: "90%",
    },
  },
  PasswordButton: {
    backgroundColor: colors.primary,
    width: "100%",
    color: "#ffffff",
    border: "1px solid #824ED2",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "500",
    borderRadius: 6,
    marginTop: 20,
    cursor: "pointer",
    fontFamily: 'Poppins-Medium',
    height: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  NewUserContainer: {
    display: "flex",
    marginTop: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  NewUserText: {
    color: colors.titleColor,
    fontSize: 16,
    fontWeight: "500",
    fontFamily: 'Poppins-Medium'

  },
  ForgotText: {
    color: colors.redColor,
    fontSize: 16,
    fontWeight: "500",
    marginLeft: 20,
    fontFamily: 'Poppins-Medium'


  },
}));
